import * as angular from "angular";
import {Link} from "../models/link.model";
import {GroupsService} from "../common/groups/groups.service";
import {StudyProgram} from "../models/study-program.model";
import {Preference} from "../models/preference.model";
import {UserSessionService} from "../common/user-session/user-session.service";
import {TestprepRootScope} from "../models/testprep-rootscope.model";
import {MessagingService} from "../common/messaging/messaging.service";
import {StudyProgramsService} from "../common/study-programs/study-programs.service";

const STUDYPROGRAMS = "studyPrograms";
const PREFERENCE = "preference";
const SAT_PREP = "nav-sat-prep-24";
const ACT_PREP = "naviance-act-2025-prep";
const SUCCESS_MESSAGE_KEY = "successMessage";
const MESSAGE_KEY = "manageDefaults";

export class ManageDefaultsController {
    // TODO add logic to obtain current default settings
    crumbs: Link[];
    district: boolean;
    districtManagedDefaultGroups: boolean = false;
    showActPrep: boolean = false;
    actPrep: boolean;
    showSatPrep: boolean = false;
    satPrep: boolean;
    showError: boolean = false;
    showManageDefaultAlert: boolean = false;
    preference: Preference;
    preferenceData: Preference;
    tenantId: string;

    /* @ngInject */
    constructor(private $route: angular.route.IRouteService,
                private $location: angular.ILocationService,
                private userSessionService: UserSessionService,
                private groupsService: GroupsService,
                private studyProgramsService: StudyProgramsService,
                private $rootScope: TestprepRootScope,
                private messagingService: MessagingService,
                public FEATURE_TOGGLE: Object) {}

    $onInit() {
        let studyPrograms = this.$route.current.locals[STUDYPROGRAMS];
        this.district = this.userSessionService.isDistrictMode();
        if (this.district) {
            this.tenantId = this.userSessionService.getDistrictTenantId();
        } else {
            this.tenantId = this.$route.current.params.tenantId;
        }
        this.updateCrumbs();
        this.preferenceData = this.$route.current.locals[PREFERENCE];
        this.getStudyProgramList(studyPrograms);
        if(this.preferenceData) { this.showAlertMessage(); }
    }

    showAlertMessage() {
        if(this.preferenceData && this.preferenceData.preferences) {
            let preferences = this.preferenceData.preferences;
            this.actPrep = preferences.act || false;
            this.satPrep = preferences.sat || false;
            this.districtManagedDefaultGroups = preferences.districtManagedDefaultGroups;
            let seenAlertMessage = preferences.seenManageDefaultAlertMessage;
                
            if((this.actPrep || this.satPrep) && !seenAlertMessage) {
                this.showManageDefaultAlert = true;
                this.actPrep = false;
                this.satPrep = false;
            }
        }
    }

    dismissAlertMessage() { this.showManageDefaultAlert = false; }

    showDefaultsTable(): boolean { return !this.district || this.districtManagedDefaultGroups; }

    goHome = (): void => {
        this.$location.path(`/${this.tenantId}`);
    };

    toggleChange = (name: string, value: boolean): void => { this[name] = value; };

    submit(): void {
        let data = {
            districtManagedDefaultGroups: this.districtManagedDefaultGroups,
            actPrepDefault: this.actPrep,
            satPrepDefault: this.satPrep
        };
        this.$rootScope.loadingView = true;
        this.groupsService.updateDefaultGroupPreferences(this.tenantId, data).then(this.handleResponse, this.errorCallback);
    }

    private updateCrumbs(): void {
        if (this.district) {
            this.crumbs = [
                { name: "Naviance Test Prep: District", url: `${this.tenantId}` },
                { name: "Manage Default Study Programs" }
            ];
        } else {
            this.crumbs = [
                { name: "Naviance Test Prep", url: `${this.tenantId}` },
                { name: "Manage Default Study Programs" }
            ];
        }
    }

    private getStudyProgramList(studyPrograms: StudyProgram[]): void {
        // TODO this method will likely change current default preferences become available
        studyPrograms.forEach((program: StudyProgram) => {
            if (program.courseSlug === ACT_PREP) { this.showActPrep = true; }
            if (program.courseSlug === SAT_PREP) { this.showSatPrep = true; }
        });
    }

    errorCallback = (): void => {
        this.$rootScope.loadingError = true;    
        this.$rootScope.loadingView = false;
    };

    private handleResponse = (status: number): void => {
        if (status < 400) {
            this.$rootScope.successMessage = this.messagingService(MESSAGE_KEY)[SUCCESS_MESSAGE_KEY];
            this.studyProgramsService.clearStudyProgramsCache();
            this.$location.path(this.crumbs[0].url);
        } else {
            this.errorCallback();
        }
    };
}



/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./app/manage-defaults/manage-defaults.controller.ts
 **/